/* eslint-disable object-curly-newline */
import React from 'react';
import Lottie from 'react-lottie';

import { Container, Header, Body, Bottom, Warning } from './styles';

import logo from '~/assets/images/logo-apollo.png';
import vagas from '~/assets/images/jobs.png';
import challenge from '~/assets/images/challenge.png';
import computer from '~/assets/animations/computer.json';

function Mobile() {
  return (
    <Container>
      <Header>
        <img
          src={logo}
          alt="logo-apollo"
          className="logo"
          style={{ width: '70%' }}
        />
        <p className="title">Se torne um Apollo Partner</p>
        <p className="subtitle">
          Na Apollo você trabalha nas melhores empresas de tecnologia, é bem
          remunerado e valorizado.
        </p>
        <p className="description">
          Somos parceiro de diversos tipos de empresas, com tamanhos, negócios e
          necessidades diferentes.
        </p>
        <img src={vagas} alt="jobs-apollo" className="jobs" />
      </Header>
      <Body>
        <p className="title">
          Faça os desafios da Apollo, aumente seu nível na plataforma para
          conseguir a vaga que você quer.
        </p>
        <p className="subtitle">
          Além de desafios de tecnologia e programaçāo, também temos desafios de
          negócios.
        </p>
        <p className="description">
          Ser um profissional Apollo é ser um profissional completo, além da
          tecnologia.
        </p>
        <img src={challenge} alt="desafio" className="desafio" />
      </Body>
      <Bottom>
        <p className="title">
          Ao fazer os desafios você irá aumentar seu nível na plataforma.
        </p>
        <p className="subtitle">
          Podemos entrar em contato com você para alocar em uma vaga, ou você
          mesmo pode se candidatar e batermos um papo sobre a vaga. E se tudo
          estiver certo, você começa a trabalhar imediatamente.
        </p>
        <p className="description">
          A Apollo possui oportunidades para profissionais iniciantes e mais
          experientes. Valorizamos a mentalidade e a atitude correta, mais do
          que histórico profissional.
        </p>
      </Bottom>
      <Warning>
        <p className="description2">Somos assim, focados em resultado!</p>

        <p className="description">
          Para acessar todos os recursos da plataforma, acesse por um
          computador.
        </p>
        <Lottie
          options={{
            loop: false,
            autoplay: true,
            animationData: computer,
          }}
          height={250}
          width={250}
          style={{ marginTop: 30 }}
        />
        <p style={{ fontSize: 14, marginTop: 40 }}>Apollo Partners Company®</p>
      </Warning>
    </Container>
  );
}

export default Mobile;
